// Steps for homepage
const hiringSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: "🙋<br>Let' start",
        description: '<b>This page gives you an overview of all current candidates. </b>',
        position: 'center',
        showButtons: true,
    },

},
{
    element: ".datatable-top-bar",
    popover: {
        title: '🥳<br>Timeline gives you an overview of the whole recruitment process',
        description: 'You can scroll through the recruitment phases and <b>see the candidates who are currently going through the recruitment phase.</b> In the red circle <div class="badge badge-timeline-red"><span>3</span></div> you can see their total number.',
        position: 'bottom-right',
        showButtons: true,
    },
},
{
    element: ".top-corner-add-button",
    popover: {
        title: ' ',
        description: '<b>New candidates</b> can be added here.',
        position: 'left',
        showButtons: true,
    },

},
{
    element: ".table",
    popover: {
        title: '🧑<br>Candidate overview',
        description: 'You can add tags, experience, ★ ratings and your own notes to each candidate.',
        position: 'bottom-center',
        showButtons: true,
    },

},
{
    element: "#filter_with_job-hiring",
    popover: {
        title: ' ',
        description: '<b>In the default state you can see all candidates regardless of the job. </b>For a close inspection, you may filter the results by job title. In this way you can easily check the progress of recruitment for a critical job.',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".filters-bar",
    popover: {
        title: '💪<br>Advanced filtering',
        description: '<b>In this way you can easily view only candidates who meet all your criteria.</b> For example, applicants with a certain label that you have rated 2★. <br><br>The search will help you, in turn, to find candidates quickly by name quickly',
        position: 'bottom',
        showButtons: true,
    },

},

{
    element: ".action-td",
    popover: {
        title: ' ' ,
        description: "<b>The perfect candidate? ✨</b> You can send him/her to a preselection right now. Just choose 'Preselection' instead of 'New candidates'.",
        position: 'bottom-right',
        showButtons: true,
    },


},
{
    element: ".edit",
    popover: {
        className: 'image-popover',
        title: '<a href="../hiring?profile=12" target="_blank" title="More"><img src="/images/guide-hiring-1.png"></a>',
        description: 'By clicking on the icon <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg> you can open profiles of your candidates. You can edit anything here, e.g. add a new note ✍️',
        position: 'bottom-right',
        showButtons: true,
    },
    onNext: () => {
        $('.modal .close').trigger('click');
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);

    }
},
{
    element: ".datatable-td",
    popover: {
        title: '🚫<br>Mass rejection of applicants',
        description: '<b>Just mark uninteresting applicants,</b> write down your message and Onboardio will send it to all selected candidates instead of you. <br><br>You can choose your own email text or use a pre-made template to <b>spare a lot of time</b> ⏱️<br><br>  <i>You can also perform other collective actions.</i>',
        position: 'right',
        showButtons: true,
    },
    onNext: () => {
        setTimeout(function(){ $('#row-select-all').trigger('click'); }, 1000);

    }
},
// {
//     element: ".align-self-start",
//     popover: {
//         title: ' ',
//         description: 'You can add candidates manually. Large number of applicants, e.g. from a recruitment agency, can be uploaded directly into Hiringo <b> from a supplied spreadsheet (Excel or CSV),
//         position: 'top',
//         showButtons: true,
//     },
//
// },
{
    element: "#sidebar",
    popover: {
        className: 'first-step-popover-class',
        title: 'Great job!',
        description: 'Discover your talent pool (1 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Yes, carry on',
        nextBtnText: 'Understood', // Next button text for this step
        prevBtnText: 'Back',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/talentpool#guide");

    }
},
]



export default hiringSteps
